module.exports = __webpack_public_path__ + "media/images/home/mini/screen_9-53595506d742445a3a411a7960e22105.png";